var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('li',{staticClass:"pwa-prompt"},[_c('button',{staticClass:"purple-button",on:{"click":_vm.installPWA}},[_vm._v(" ⬇ Установить ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }